interface ExportFooterProps {
  appName?: string
}

export function ExportFooter({
  appName = 'Sportable Reporting'
}: ExportFooterProps) {
  const today = new Date().toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })

  return (
    <div className='hidden print:mt-8 print:block'>
      <hr className='mb-2 border-gray-300' />
      <div className='grid grid-cols-3 text-[7pt] text-gray-500'>
        <span className='text-left'>Exported from {appName}</span>
        <span className='text-center'>{today}</span>
        <span className='text-right'>sportable.com</span>
      </div>
    </div>
  )
}
